// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   GLOBAL UI COMPONENT STYLES
   Standardized styles for consistent UI/UX
   ============================================ */

/* ============================================
   THEME COLORS
   ============================================ */
:root {
  --primary-color: #009e8c;
  --primary-hover: rgba(0, 158, 140, 0.8);
  --secondary-color: #6c757d;
  --success-color: #28a745;
  --danger-color: #dc3545;
  --warning-color: #ffc107;
  --info-color: #17a2b8;
  --light-color: #f8f9fa;
  --dark-color: #343a40;
  --border-color: #e0e0e0;
  --text-muted: #6c757d;
}

/* ============================================
   TABLES - Standardized Table Styles
   ============================================ */
.standard-table-wrapper {
  width: 100%;
  overflow-x: auto;
  margin-top: 1rem;
}

.standard-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.standard-table thead {
  background-color: #f8f9fa;
  border-bottom: 2px solid var(--border-color);
}

.standard-table thead th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: var(--dark-color);
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.standard-table tbody tr {
  border-bottom: 1px solid var(--border-color);
  transition: background-color 0.2s ease;
}

.standard-table tbody tr:hover {
  background-color: #f8f9fa;
}

.standard-table tbody tr:last-child {
  border-bottom: none;
}

.standard-table tbody td {
  padding: 12px 16px;
  font-size: 0.875rem;
  color: var(--dark-color);
  vertical-align: middle;
}

.standard-table tbody td:first-child {
  font-weight: 500;
}

/* Empty state */
.standard-table-empty {
  text-align: center;
  padding: 3rem 1rem;
  color: var(--text-muted);
}

.standard-table-empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

/* ============================================
   MODALS - Standardized Modal Styles
   ============================================ */
.standard-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  z-index: 1050;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.standard-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}

.standard-modal-header {
  padding: 1.5rem;
  border-bottom: 1px solid var(--border-color);
  background-color: #f8f9fa;
}

.standard-modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--dark-color);
  margin: 0;
}

.standard-modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--text-muted);
  padding: 0.25rem;
  line-height: 1;
  transition: color 0.2s ease;
}

.standard-modal-close:hover {
  color: var(--dark-color);
}

.standard-modal-body {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1 1;
}

.standard-modal-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border-color);
  background-color: #f8f9fa;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

/* ============================================
   FORMS - Standardized Form Styles
   ============================================ */
.standard-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.standard-form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.standard-form-label {
  font-weight: 500;
  color: var(--dark-color);
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
}

.standard-form-label.required::after {
  content: " *";
  color: var(--danger-color);
}

.standard-form-input,
.standard-form-select,
.standard-form-textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-size: 0.875rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}

.standard-form-input:focus,
.standard-form-select:focus,
.standard-form-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(0, 158, 140, 0.1);
}

.standard-form-input:disabled,
.standard-form-select:disabled,
.standard-form-textarea:disabled {
  background-color: #f8f9fa;
  cursor: not-allowed;
  opacity: 0.6;
}

.standard-form-textarea {
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
}

.standard-form-error {
  color: var(--danger-color);
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

.standard-form-help {
  color: var(--text-muted);
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

/* ============================================
   BUTTONS - Standardized Button Styles
   ============================================ */
.standard-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  gap: 0.5rem;
  white-space: nowrap;
}

.standard-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.standard-btn-primary {
  background-color: var(--primary-color);
  color: white;
}

.standard-btn-primary:hover:not(:disabled) {
  background-color: var(--primary-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 158, 140, 0.2);
}

.standard-btn-secondary {
  background-color: var(--secondary-color);
  color: white;
}

.standard-btn-secondary:hover:not(:disabled) {
  background-color: #5a6268;
  transform: translateY(-1px);
}

.standard-btn-success {
  background-color: var(--success-color);
  color: white;
}

.standard-btn-success:hover:not(:disabled) {
  background-color: #218838;
  transform: translateY(-1px);
}

.standard-btn-danger {
  background-color: var(--danger-color);
  color: white;
}

.standard-btn-danger:hover:not(:disabled) {
  background-color: #c82333;
  transform: translateY(-1px);
}

.standard-btn-outline {
  background-color: transparent;
  border: 1px solid var(--border-color);
  color: var(--dark-color);
}

.standard-btn-outline:hover:not(:disabled) {
  background-color: #f8f9fa;
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.standard-btn-sm {
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
}

.standard-btn-lg {
  padding: 0.875rem 1.75rem;
  font-size: 1rem;
}

.standard-btn-icon {
  width: 1.25rem;
  height: 1.25rem;
}

/* Button groups */
.standard-btn-group {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.standard-btn-group-right {
  justify-content: flex-end;
}

.standard-btn-group-center {
  justify-content: center;
}

/* ============================================
   ACTION BUTTONS - Table Action Buttons
   ============================================ */
.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.375rem;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;
  margin: 0 0.25rem;
}

.action-btn:hover {
  background-color: #f8f9fa;
  transform: scale(1.1);
}

.action-btn-edit {
  color: var(--success-color);
}

.action-btn-delete {
  color: var(--danger-color);
}

.action-btn-view {
  color: var(--info-color);
}

.action-btn-icon {
  width: 1.25rem;
  height: 1.25rem;
}

/* ============================================
   LOADING STATES
   ============================================ */
.standard-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: var(--text-muted);
}

.standard-loading-spinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--border-color);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ============================================
   EMPTY STATES
   ============================================ */
.standard-empty-state {
  text-align: center;
  padding: 3rem 1rem;
  color: var(--text-muted);
}

.standard-empty-state-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.standard-empty-state-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: var(--dark-color);
}

.standard-empty-state-text {
  font-size: 0.875rem;
  margin-bottom: 1.5rem;
}

/* ============================================
   BADGES & STATUS
   ============================================ */
.standard-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 12px;
  white-space: nowrap;
}

.standard-badge-success {
  background-color: #d4edda;
  color: #155724;
}

.standard-badge-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.standard-badge-warning {
  background-color: #fff3cd;
  color: #856404;
}

.standard-badge-info {
  background-color: #d1ecf1;
  color: #0c5460;
}

.standard-badge-primary {
  background-color: rgba(0, 158, 140, 0.1);
  color: var(--primary-color);
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */
@media (max-width: 768px) {
  .standard-modal {
    width: 95%;
    max-height: 95vh;
  }

  .standard-table-wrapper {
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .standard-table {
    min-width: 600px;
  }

  .standard-btn-group {
    flex-direction: column;
    width: 100%;
  }

  .standard-btn-group .standard-btn {
    width: 100%;
  }
}

/* ============================================
   UTILITY CLASSES
   ============================================ */
.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.mt-1 { margin-top: 0.25rem; }
.mt-2 { margin-top: 0.5rem; }
.mt-3 { margin-top: 1rem; }
.mt-4 { margin-top: 1.5rem; }

.mb-1 { margin-bottom: 0.25rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mb-3 { margin-bottom: 1rem; }
.mb-4 { margin-bottom: 1.5rem; }

.p-1 { padding: 0.25rem; }
.p-2 { padding: 0.5rem; }
.p-3 { padding: 1rem; }
.p-4 { padding: 1.5rem; }

`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD;;iDAEiD;AACjD;EACE,wBAAwB;EACxB,uCAAuC;EACvC,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;iDAEiD;AACjD;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;iDAEiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;iDAEiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;iDAEiD;AACjD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;iDAEiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;;iDAEiD;AACjD;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;iDAEiD;AACjD;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,kBAAkB,EAAE;;AAE5B,QAAQ,sBAAsB,EAAE;AAChC,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,qBAAqB,EAAE;;AAE/B,OAAO,gBAAgB,EAAE;AACzB,OAAO,eAAe,EAAE;AACxB,OAAO,aAAa,EAAE;AACtB,OAAO,eAAe,EAAE","sourcesContent":["/* ============================================\n   GLOBAL UI COMPONENT STYLES\n   Standardized styles for consistent UI/UX\n   ============================================ */\n\n/* ============================================\n   THEME COLORS\n   ============================================ */\n:root {\n  --primary-color: #009e8c;\n  --primary-hover: rgba(0, 158, 140, 0.8);\n  --secondary-color: #6c757d;\n  --success-color: #28a745;\n  --danger-color: #dc3545;\n  --warning-color: #ffc107;\n  --info-color: #17a2b8;\n  --light-color: #f8f9fa;\n  --dark-color: #343a40;\n  --border-color: #e0e0e0;\n  --text-muted: #6c757d;\n}\n\n/* ============================================\n   TABLES - Standardized Table Styles\n   ============================================ */\n.standard-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  margin-top: 1rem;\n}\n\n.standard-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.standard-table thead {\n  background-color: #f8f9fa;\n  border-bottom: 2px solid var(--border-color);\n}\n\n.standard-table thead th {\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: var(--dark-color);\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.standard-table tbody tr {\n  border-bottom: 1px solid var(--border-color);\n  transition: background-color 0.2s ease;\n}\n\n.standard-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.standard-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.standard-table tbody td {\n  padding: 12px 16px;\n  font-size: 0.875rem;\n  color: var(--dark-color);\n  vertical-align: middle;\n}\n\n.standard-table tbody td:first-child {\n  font-weight: 500;\n}\n\n/* Empty state */\n.standard-table-empty {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: var(--text-muted);\n}\n\n.standard-table-empty-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n/* ============================================\n   MODALS - Standardized Modal Styles\n   ============================================ */\n.standard-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  z-index: 1050;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.standard-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1040;\n  backdrop-filter: blur(2px);\n}\n\n.standard-modal-header {\n  padding: 1.5rem;\n  border-bottom: 1px solid var(--border-color);\n  background-color: #f8f9fa;\n}\n\n.standard-modal-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--dark-color);\n  margin: 0;\n}\n\n.standard-modal-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: var(--text-muted);\n  padding: 0.25rem;\n  line-height: 1;\n  transition: color 0.2s ease;\n}\n\n.standard-modal-close:hover {\n  color: var(--dark-color);\n}\n\n.standard-modal-body {\n  padding: 1.5rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.standard-modal-footer {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border-color);\n  background-color: #f8f9fa;\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n/* ============================================\n   FORMS - Standardized Form Styles\n   ============================================ */\n.standard-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.standard-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.standard-form-label {\n  font-weight: 500;\n  color: var(--dark-color);\n  font-size: 0.875rem;\n  margin-bottom: 0.25rem;\n}\n\n.standard-form-label.required::after {\n  content: \" *\";\n  color: var(--danger-color);\n}\n\n.standard-form-input,\n.standard-form-select,\n.standard-form-textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  font-size: 0.875rem;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  box-sizing: border-box;\n}\n\n.standard-form-input:focus,\n.standard-form-select:focus,\n.standard-form-textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(0, 158, 140, 0.1);\n}\n\n.standard-form-input:disabled,\n.standard-form-select:disabled,\n.standard-form-textarea:disabled {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.standard-form-textarea {\n  resize: vertical;\n  min-height: 100px;\n  font-family: inherit;\n}\n\n.standard-form-error {\n  color: var(--danger-color);\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n}\n\n.standard-form-help {\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n}\n\n/* ============================================\n   BUTTONS - Standardized Button Styles\n   ============================================ */\n.standard-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.625rem 1.25rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  gap: 0.5rem;\n  white-space: nowrap;\n}\n\n.standard-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.standard-btn-primary {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n.standard-btn-primary:hover:not(:disabled) {\n  background-color: var(--primary-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 158, 140, 0.2);\n}\n\n.standard-btn-secondary {\n  background-color: var(--secondary-color);\n  color: white;\n}\n\n.standard-btn-secondary:hover:not(:disabled) {\n  background-color: #5a6268;\n  transform: translateY(-1px);\n}\n\n.standard-btn-success {\n  background-color: var(--success-color);\n  color: white;\n}\n\n.standard-btn-success:hover:not(:disabled) {\n  background-color: #218838;\n  transform: translateY(-1px);\n}\n\n.standard-btn-danger {\n  background-color: var(--danger-color);\n  color: white;\n}\n\n.standard-btn-danger:hover:not(:disabled) {\n  background-color: #c82333;\n  transform: translateY(-1px);\n}\n\n.standard-btn-outline {\n  background-color: transparent;\n  border: 1px solid var(--border-color);\n  color: var(--dark-color);\n}\n\n.standard-btn-outline:hover:not(:disabled) {\n  background-color: #f8f9fa;\n  border-color: var(--primary-color);\n  color: var(--primary-color);\n}\n\n.standard-btn-sm {\n  padding: 0.375rem 0.75rem;\n  font-size: 0.75rem;\n}\n\n.standard-btn-lg {\n  padding: 0.875rem 1.75rem;\n  font-size: 1rem;\n}\n\n.standard-btn-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* Button groups */\n.standard-btn-group {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.standard-btn-group-right {\n  justify-content: flex-end;\n}\n\n.standard-btn-group-center {\n  justify-content: center;\n}\n\n/* ============================================\n   ACTION BUTTONS - Table Action Buttons\n   ============================================ */\n.action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.375rem;\n  border: none;\n  background: none;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  margin: 0 0.25rem;\n}\n\n.action-btn:hover {\n  background-color: #f8f9fa;\n  transform: scale(1.1);\n}\n\n.action-btn-edit {\n  color: var(--success-color);\n}\n\n.action-btn-delete {\n  color: var(--danger-color);\n}\n\n.action-btn-view {\n  color: var(--info-color);\n}\n\n.action-btn-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* ============================================\n   LOADING STATES\n   ============================================ */\n.standard-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  color: var(--text-muted);\n}\n\n.standard-loading-spinner {\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid var(--border-color);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ============================================\n   EMPTY STATES\n   ============================================ */\n.standard-empty-state {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: var(--text-muted);\n}\n\n.standard-empty-state-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.standard-empty-state-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: var(--dark-color);\n}\n\n.standard-empty-state-text {\n  font-size: 0.875rem;\n  margin-bottom: 1.5rem;\n}\n\n/* ============================================\n   BADGES & STATUS\n   ============================================ */\n.standard-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  border-radius: 12px;\n  white-space: nowrap;\n}\n\n.standard-badge-success {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.standard-badge-danger {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.standard-badge-warning {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.standard-badge-info {\n  background-color: #d1ecf1;\n  color: #0c5460;\n}\n\n.standard-badge-primary {\n  background-color: rgba(0, 158, 140, 0.1);\n  color: var(--primary-color);\n}\n\n/* ============================================\n   RESPONSIVE DESIGN\n   ============================================ */\n@media (max-width: 768px) {\n  .standard-modal {\n    width: 95%;\n    max-height: 95vh;\n  }\n\n  .standard-table-wrapper {\n    overflow-x: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .standard-table {\n    min-width: 600px;\n  }\n\n  .standard-btn-group {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .standard-btn-group .standard-btn {\n    width: 100%;\n  }\n}\n\n/* ============================================\n   UTILITY CLASSES\n   ============================================ */\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.mt-1 { margin-top: 0.25rem; }\n.mt-2 { margin-top: 0.5rem; }\n.mt-3 { margin-top: 1rem; }\n.mt-4 { margin-top: 1.5rem; }\n\n.mb-1 { margin-bottom: 0.25rem; }\n.mb-2 { margin-bottom: 0.5rem; }\n.mb-3 { margin-bottom: 1rem; }\n.mb-4 { margin-bottom: 1.5rem; }\n\n.p-1 { padding: 0.25rem; }\n.p-2 { padding: 0.5rem; }\n.p-3 { padding: 1rem; }\n.p-4 { padding: 1.5rem; }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
